module.exports = __webpack_public_path__ + "assets/home-tab.0a8f8720.svg";